import Global from "../config/config.json";
import httpService from "../config/httpService";
const authAPI= {
    async login(mobile) {
        let res = [];
 
        await httpService
            .post(`${Global.Nameh}auth/generate`,{mobile:mobile})
            .then((json) => {
               
                switch (json.status) {
                    case 201:
                    case 200:
                        res = json.data
                        break;
                }
            })
        return res;
    },
    async otp(mobile,code) {
        let res = [];
        await httpService
            .post(`${Global.Nameh}auth/login`,{mobile:mobile,otp:code})
            .then((json) => {
                console.log("code", json)
                switch (json.status) {
                    case 201:
                    case 200:
                        res = json.data
                        break;
                }
            })
        return res;
    },
    async refresh(refreshToken) {
        let res = [];
        await httpService
            .post(`${Global.Nameh}auth/refresh`,{refreshtoken:refreshToken})
            .then((json) => {
                console.log("refresh", json)
                switch (json.status) {
                    case 201:
                    case 200:
                        res = json.data
                        break;
                }
            })
        
        return res;
    },
    async logout(jwt) {
        let res = [];
        await httpService
            .post(`${Global.Nameh}auth/logout`,{}
            ,{
                headers:{Authorization: `${jwt.token_type} ${jwt.access_token}`}
            })
            .then((json) => {
                console.log("refresh", json)
                switch (json.status) {
                    case 201:
                    case 200:
                        res = json.data
                        break;
                }
            })
        
        return res;
    }
}
export default authAPI